<div class="body">

    <div *ngFor="let picture of pictures" class="picture-wrapper">

        <div class="controls">

            <button mat-icon-button color="warn" (click)="deletePicture(picture)">
                <mat-icon>clear</mat-icon>
            </button>

        </div>

        <img [src]="picture.picturedata|picture:picture.picturemediatype" />

    </div>

    <div class="picture-wrapper">

        <button mat-raised-button color="primary" (click)="upload.click()" [disabled]="!canUpload">
            Upload
        </button>

    </div>

</div>

<input type="file" accept="image/png, image/jpeg" style="display: none;" #upload (input)="uploadPictures($event)" />
